<div class="flex-fill w-100">
  <div class="d-flex mb-2 align-items-center" *ngIf="!isDraft">
    <div
      class="d-flex align-items-center gap-2"
      (click)="collapse.emit(!collapsed)"
      [matTooltip]="toggleCollapsingTooltip"
      matTooltipPosition="below"
    >
      <div
        *ngIf="message.type === MessageType.Inbound || message.type === MessageType.Guest"
        class="d-flex align-items-center gap-2 text-bold"
      >
        <app-avatar [text]="guestName" [size]="24"></app-avatar>
        <span>
          {{ guestName | truncate : 25 }}
        </span>
        <span i18n>to</span>
        <span> AdvanceCM </span>
      </div>
      <div
        *ngIf="message.type === MessageType.Outbound || message.type === MessageType.Draft"
        class="d-flex align-items-center gap-2 text-bold"
      >
        <app-avatar [image]="isBot ? '/assets/images/icons/ai-avatar.svg' : 'assets/logo.svg'" [size]="24"></app-avatar>
        <span>
          {{ message.name || 'Unknown sender' | truncate : 25 }}
        </span>
        <span i18n>to</span>
        <span>
          {{ guestName | truncate : 25 }}
        </span>
      </div>
      <div class="text-sm text-light" *ngIf="!isDraft">
        {{ message.receivedOn | epoch : 'D-MMM-YYYY / H:mm A' }}
      </div>
      <span
        *ngIf="message.editedAt && !message.unsentAt"
        class="text-sm text-light"
        [matTooltip]="'Edited ' + (message.editedAt | epoch : 'D-MMM-YYYY / H:mm A')"
        matTooltipPosition="above"
      >
        <i class="fal fa-pen"></i> <ng-container i18n>Edited</ng-container>
      </span>
      <i class="fas fa-clock text-warning" *ngIf="message.isSending" matTooltip="Message is being sent"></i>
      <i
        class="fas fa-exclamation-triangle text-danger"
        *ngIf="!isMessageDelivered"
        [matTooltip]="message.delivery_message || 'Message not delivered'"
      ></i>
      <message-sent-with
        [sentWith]="message.sentWith"
        platform="tokeet"
        class="d-inline-block ml-2"
      ></message-sent-with>
    </div>
    <div class="flex-fill"></div>
    <ng-content select="[actions]"></ng-content>
  </div>

  <div *ngIf="collapsed" class="collapsed-content" (click)="collapse.emit(!collapsed)">
    <div *ngIf="message.statusText">{{ message.statusText }}</div>
    <div
      *ngIf="!message.statusText"
      [innerHtml]="message.messageTxt || message.messageHtml || 'Message collapsed.'"
    ></div>
    <i class="fal fa-chevron-double-down"></i>
  </div>

  <div *ngIf="!collapsed && message.unsentAt" class="bg-default2 p-3 rounded text-light unsent">
    <i class="fal fa-ban"></i> <ng-container i18n>This message was unsent</ng-container>
  </div>

  <ng-container *ngIf="!collapsed && !message.unsentAt">
    <div
      *ngIf="(message.messageTxt && !message.messageHtml) || viewPlainText"
      class="bg-default2 p-3 rounded"
      [ngClass]="{ clickable: clickable }"
      (click)="bodyClick.emit()"
    >
      <div [innerHtml]="message.messageTxt"></div>
      <ng-container *ngTemplateOutlet="quote"></ng-container>
    </div>

    <div
      *ngIf="!viewPlainText"
      class="bg-default2 p-3 rounded"
      [ngClass]="{ clickable: clickable }"
      (click)="bodyClick.emit()"
    >
      <div class="message-content">
        <div [innerHtml]="message.sanitizedMsgHtml"></div>
        <div *ngIf="!message.messageHtml && !message.attachments?.length" class="text-light">&lt;Empty Content&gt;</div>
        <ng-container *ngTemplateOutlet="quote"></ng-container>
        <ng-container *ngTemplateOutlet="attachments"></ng-container>
      </div>
      <div *ngIf="message.attributes?.aiResponder?.summary as summary" class="mt-3">
        <span class="d-inline-block px-2 bg-white text-xs">
          <i class="flag-icon-squared mr-1 flag-icon flag-icon-gb"></i>
          <ng-container i18n>English Summary</ng-container>
        </span>
        <div class="alert alert-secondary-warning2">
          <div [innerHtml]="summary"></div>
        </div>
      </div>

      <div *ngIf="isDraft" class="draft-actions mt-2">
        <div>Not happy? <a href="javascript:;" (click)="onAIGenerate()" i18n>Generate another response</a></div>
        <a class="draft-action" i18n-matTooltip matTooltip="Edit this message draft" (click)="onEditDraft(message)"
          ><i class="cs-icon cs-icon-pencil"></i
        ></a>
        <a class="draft-action" i18n-matTooltip matTooltip="Send this message to guest" (click)="onSendDraft(message)"
          ><i class="fa fa-paper-plane"></i
        ></a>
        <a
          class="draft-action danger"
          i18n-matTooltip
          matTooltip="Remove this message draft"
          (click)="onRemoveDraft(message)"
          ><i class="cs-icon cs-icon-trash"></i
        ></a>
      </div>
    </div>
  </ng-container>

  <!-- TV4-6323: Airbnb removed a phone number from this host message and added a contact card. -->
  <div *ngIf="!collapsed && !message.unsentAt && message.airbnbText" class="text-sm text-light mt-2">
    <i class="fal fa-phone-slash"></i>
    <ng-container i18n>Airbnb removed the phone number. The guest sees:</ng-container>
    {{ message.airbnbText }}
  </div>

  <div *ngIf="!collapsed && message.reactions?.length" class="d-flex flex-wrap gap-2 mt-2">
    <span
      *ngFor="let reaction of message.reactions"
      class="reaction"
      [matTooltip]="reactionTooltip(reaction)"
      matTooltipPosition="above"
    >
      <span class="emoji">{{ reaction.emoji }}</span
      >{{ reaction.name }}
    </span>
  </div>

  <ng-template #quote>
    <div *ngIf="isQuote">
      <h4 i18n>Your Quote</h4>
      <div></div>
      <table *ngIf="!inquiry?.bookingEngine">
        <tr>
          <th i18n>Base Rate:</th>
          <td><span [innerHtml]="message.charge | tokeetCurrency : currency"></span></td>
        </tr>
        <tr>
          <th i18n>Discounts & Fees:&nbsp;&nbsp;</th>
          <td><span [innerHtml]="message.discounts | tokeetCurrency : currency"></span></td>
        </tr>
        <tr>
          <th i18n>Tax:</th>
          <td><span [innerHtml]="message.taxFee | tokeetCurrency : currency"></span></td>
        </tr>
        <tr class="quote-total">
          <th i18n>Total Amount:</th>
          <td><span [innerHtml]="message.sum | tokeetCurrency : currency"></span></td>
        </tr>
      </table>
      <table *ngIf="inquiry?.bookingEngine">
        <tr>
          <th i18n>Base Charge:&nbsp;&nbsp;</th>
          <td>
            <span [innerHtml]="inquiry?.bookingEngine?.extraBedroomsBase | tokeetCurrency : currency"></span>
          </td>
        </tr>
        <tr>
          <th i18n>Additional Guests Fee:&nbsp;&nbsp;</th>
          <td><span [innerHtml]="inquiry?.bookingEngine?.extraGuests | tokeetCurrency : currency"></span></td>
        </tr>
        <tr *ngIf="!!inquiry?.bookingEngine?.extraBedrooms">
          <th i18n>Additional Bedrooms Fee:&nbsp;&nbsp;</th>
          <td><span [innerHtml]="inquiry?.bookingEngine?.extraBedrooms | tokeetCurrency : currency"></span></td>
        </tr>
        <tr>
          <th i18n>Discounts & Fees:&nbsp;&nbsp;</th>
          <td><span [innerHtml]="inquiry?.bookingEngine?.discountTotal | tokeetCurrency : currency"></span></td>
        </tr>
        <tr *ngFor="let fee of inquiry?.bookingEngine?.bookingFees">
          <th>{{ fee.name }}</th>
          <td><span [innerHtml]="fee.amount | tokeetCurrency : currency"></span></td>
        </tr>
        <tr>
          <th i18n>Taxes:</th>
          <td><span [innerHtml]="inquiry?.bookingEngine?.taxTotal | tokeetCurrency : currency"></span></td>
        </tr>
        <tr class="quote-total">
          <th i18n>Total:</th>
          <td><span [innerHtml]="inquiry?.bookingEngine?.total | tokeetCurrency : currency"></span></td>
        </tr>
      </table>
    </div>
  </ng-template>

  <ng-template #attachments>
    <ng-container *ngIf="!message.innerAttachments">
      <div *ngFor="let attachment of message.attachments">
        <!-- TV4-6337: an Airbnb video links to the message in Airbnb, only when the video is ready. -->
        <div *ngIf="attachment.type === 'video'" class="video-card">
          <i class="fal fa-video"></i>
          <a *ngIf="attachment.status === 'READY'" [href]="attachment.url" target="_blank" rel="noopener"
            >{{ attachment.name }}&nbsp;&nbsp;<i class="fal fa-external-link"></i
          ></a>
          <span *ngIf="attachment.status !== 'READY'" class="text-light">{{ attachment.name }}</span>
        </div>
        <a
          *ngIf="attachment.type !== 'video' && !attachment.path && !!attachment.url"
          [href]="attachment.url"
          target="_blank"
          >{{ attachment.name }}&nbsp;&nbsp;<i class="fal fa-paperclip"></i
        ></a>
        <a *ngIf="!!attachment.path && !attachment.url" (click)="onDownloadAttachment(attachment)"
          >{{ attachment.name }}&nbsp;&nbsp;<i class="fal fa-paperclip"></i
        ></a>
      </div>
    </ng-container>
  </ng-template>
</div>
